import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TataokhomeComponent } from './tataokhome/tataokhome.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TataokplplistComponent } from './tataokplplist/tataokplplist.component';
import { TataokfilterComponent } from './tataokfilter/tataokfilter.component';
import { TataokpdppageComponent } from './tataokpdppage/tataokpdppage.component';
import { ProductModule } from '../product/product.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { TataOkSimilarVehicleComponent } from './tata-ok-similar-vehicle/tata-ok-similar-vehicle.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LoginModule } from '../login/login.module';

const route:Routes=[
  {
    path: 'buy-used-vehicles',
    component: TataokhomeComponent,

  },
  {
    path: 'buy-used-vehicles-productlist',
    component: TataokplplistComponent,

  },
  {
    path: 'buy-used-vehicles-productlist/:id',
    component: TataokplplistComponent,

  },
  {
    path: 'buy-used-vehicles-productdetail/:id',
    component: TataokpdppageComponent,

  },
  {
    path: 'buy-used-vehicles-productdetail',
    component: TataokpdppageComponent,

  },
]

@NgModule({
  declarations: [
    TataokhomeComponent,
    TataokplplistComponent,
    TataokfilterComponent,
    TataokpdppageComponent,
    TataOkSimilarVehicleComponent
  ],
  imports: [
    SlickCarouselModule,
    CarouselModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSkeletonModule,
    NgxSliderModule,
    ProductModule,
    NgxSpinnerModule,
    LoginModule,
    RouterModule.forChild(route),
  ]
})
export class TataokModule { }
